import { atom } from "jotai";

export const socketAuthenticatedAtom = atom(false);
